import {type RootState} from 'web-app/react/redux/main-reducer';

export const shouldShowImageGallery = (state: Pick<RootState, 'imageGallery'>) =>
    Boolean(state.imageGallery.images?.length > 0);

export const getBoundingBoxFromElement = (ref: HTMLElement | null) => {
    if (!ref || !(ref instanceof Element)) {
        return {};
    }

    const pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
    const rect = ref.getBoundingClientRect();
    return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
};
